import ChooseAccount from '@components/pages/chooseAccount';

export default ChooseAccount;
